// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PjU5G","rootMobile":"styles_rootMobile__1hlIe"};